import clsx from 'clsx';

import { PopoverStylesNames } from '@mantine/core';

import classes from './Popover.module.css';

export const PopoverOverrideClassNames: (props: {
  noPadding: boolean;
}) => Partial<Record<PopoverStylesNames, string>> = (props) => {
  return {
    dropdown: clsx(classes.dropdown, {
      [classes.dropdownNoPadding]: props.noPadding
    })
  };
};
